import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDetalleSeguimientoPasstModel } from 'src/app/models/interfaces/passt/ISeguimientoPasstModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { PasstActividadReprogramarDialogComponent } from '../passt-actividad-reprogramar-dialog/passt-actividad-reprogramar-dialog.component';

@Component({
  selector: 'app-passt-actividad-cancelar-dialog',
  templateUrl: './passt-actividad-cancelar-dialog.component.html',
  styleUrls: ['./passt-actividad-cancelar-dialog.component.css']
})
export class PasstActividadCancelarDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PasstActividadReprogramarDialogComponent>,
    private confirmDialogService: ConfirmDialogService,
    @Inject(MAT_DIALOG_DATA) public model: IDetalleSeguimientoPasstModel) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  } 
  
  Save(): void{
    this.dialogRef.close(this.model);
  }

  esValido(): boolean{
    let valido:boolean=true;
    
    if(!this.model.comentarios)
      valido=false;

    return valido;
  }
}
